import { get, post, post2 } from './http'
import qs from 'qs'
// export const 接口名 = () => Network.get('/路由',参数对象);

export const weChatLogin = p => post('schoolPoints/weindex/weChatLogin', p); //登录
export const addActivityStudent = p => post('schoolPoints/student/activity/addActivityStudent', p); //添加活动
export const queryActivityStudent = p => post('/schoolPoints/student/activity/queryActivityStudent', p);//查询活动
export const integralCommodit_query = p => post('/schoolPoints/student/integralCommodity/query', p);//商品列表
export const queryCommodityHeat = p => post('/schoolPoints/student/integralCommodity/queryCommodityHeat', p);//热门商品
export const queryUser = p => post('/schoolPoints/student/integralUser/queryUser', p);//获取用户信息
export const activityScan = p => post('/schoolPoints/student/integralDetails/activityScan', p);//扫码
export const queryCommodityExchange = p => post('/schoolPoints/commodityExchange/queryCommodityExchange', p);//扫码
export const queryUserDetails = p => post('/schoolPoints/student/integralUser/queryUserDetails', p);//积分详情
export const queryCommodityHeats = p => post('/schoolPoints/student/activity/queryCommodityHeat', p);//热门活动
export const queryPersonalActivity = p => post('/schoolPoints/student/activity/queryPersonalActivity', p);//个人发布活动列表
export const queryUserCommodity = p => post('/schoolPoints/student/integralUser/queryUserCommodity', p);//个人发布活动列表



export const list = p => get('/schoolPoints/sysDict/list', p);//活动列表
export const queryIntegralCommodity = p => post('/schoolPoints/integralCommodity/queryIntegralCommodity', p);//查询全部 商品 信息
export const queryDetails = p => post('/schoolPoints/student/integralCommodity/queryDetails', p);//商品详细信息
export const shoppingCommodity = p => post('/schoolPoints/student/integralCommodity/shoppingCommodity', p);//兑换商品
export const sysDictItem_list = p => get('/schoolPoints/sysDictItem/list', p);//字典项
export const oauth = p => get('/schoolPoints/wxindex/oauth', p);//微信登录


export const listzd = p => get('/schoolPoints/sysDictItem/list', p); //字典项详情

export const apply = p => post('/schoolPoints/student/apply/apply', p); 

